import { Data } from '@blade/std-lib'

export class CancelError extends Data.TaggedError('CancelError') {
  static make = () => {
    return new CancelError()
  }
}
